import { Link } from "react-router-dom";
import Breadcrumb from "@/components/feature/Breadcrumb";
import FeedbackForm from "@/pages/about/components/FeedbackForm";
import { usePageMeta } from "@/hooks/usePageMeta";

const values = [
  { icon: "ri-newspaper-line", title: "权威资讯", desc: "及时跟进剧集与电影动态，为你梳理行业风向。" },
  { icon: "ri-compass-3-line", title: "精选推荐", desc: "从口碑与热度出发，帮你快速锁定值得一看的作品。" },
  { icon: "ri-book-2-line", title: "详实资料", desc: "整理剧集与影片的完整资料，让每一次观影都更从容。" },
];

const stats = [
  { value: "12,000+", label: "收录影视作品" },
  { value: "3,500+", label: "精选影片推荐" },
  { value: "每日更新", label: "影视资讯动态" },
  { value: "全端适配", label: "电脑手机通用" },
];

export default function AboutPage() {
  usePageMeta(
    "关于我们 - 蜜月TV",
    "了解蜜月TV的定位与理念：专注影视剧资讯与电影推荐，为影视爱好者提供权威资讯、精选推荐与详实资料。",
  );

  return (
    <div className="w-full px-4 md:px-8 py-6 md:py-8">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />

      <section className="mt-6 rounded-xl bg-secondary-900 text-background-50 overflow-hidden">
        <div className="p-8 md:p-14 max-w-3xl">
          <span className="inline-block px-3 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium mb-5">
            关于蜜月TV
          </span>
          <h1 className="text-2xl md:text-4xl font-black leading-tight">
            专注影视资讯与影片推荐的内容平台
          </h1>
          <p className="text-sm md:text-base text-secondary-200 leading-relaxed mt-5">
            蜜月TV 是一家专注于提供最新影视剧资讯和精彩电影推荐的综合影视内容网站。
            我们服务于热爱电视剧、电影与动漫的观众群体，关注影视动态、热门作品及观影指南，
            希望通过权威资讯、丰富推荐与详实资料，帮助每一位用户做出更轻松的观影决策。
          </p>
        </div>
      </section>

      <section className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
        {stats.map((item) => (
          <div key={item.label} className="rounded-lg bg-background-50 border border-background-200 p-5 text-center">
            <p className="text-xl md:text-2xl font-black text-primary-700">{item.value}</p>
            <p className="text-xs md:text-sm text-foreground-500 mt-1.5">{item.label}</p>
          </div>
        ))}
      </section>

      <section className="mt-12">
        <h2 className="text-xl md:text-2xl font-black text-foreground-950 mb-1.5">我们的理念</h2>
        <p className="text-sm text-foreground-500 mb-6">清晰的信息层级，轻松的浏览体验。</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {values.map((item) => (
            <div key={item.title} className="rounded-lg bg-background-50 border border-background-200 p-6">
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 text-2xl">
                <i className={item.icon} />
              </span>
              <h3 className="text-base font-bold text-foreground-900 mt-4">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed mt-2">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <h2 className="text-xl md:text-2xl font-black text-foreground-950 mb-1.5">联系我们</h2>
          <p className="text-sm text-foreground-500 mb-6">
            欢迎通过以下方式与我们取得联系，也欢迎在右侧提交你的反馈。
          </p>
          <div className="space-y-3">
            <div className="flex items-center gap-3 p-4 rounded-lg bg-background-50 border border-background-200">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className="ri-mail-line" />
              </span>
              <div>
                <p className="text-xs text-foreground-500">合作邮箱</p>
                <p className="text-sm font-medium text-foreground-900">hello@miyuetv.example.com</p>
              </div>
            </div>
            <div className="flex items-center gap-3 p-4 rounded-lg bg-background-50 border border-background-200">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className="ri-phone-line" />
              </span>
              <div>
                <p className="text-xs text-foreground-500">客服电话</p>
                <p className="text-sm font-medium text-foreground-900">400-000-2024</p>
              </div>
            </div>
            <div className="flex items-center gap-3 p-4 rounded-lg bg-background-50 border border-background-200">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className="ri-map-pin-line" />
              </span>
              <div>
                <p className="text-xs text-foreground-500">办公地址</p>
                <p className="text-sm font-medium text-foreground-900">中国 · 北京</p>
              </div>
            </div>
          </div>
        </div>

        <FeedbackForm />
      </section>

      <section className="mt-12 rounded-xl bg-background-100 border border-background-200 p-6 md:p-8">
        <h2 className="text-base font-bold text-foreground-950 mb-3">版权声明与隐私说明</h2>
        <p className="text-sm text-foreground-600 leading-relaxed">
          本站所展示的影视资料、封面与资讯内容均为演示用途的虚拟数据，不用于任何商业用途。
          用户提交的反馈信息仅用于内容改进与沟通，我们会妥善保护你的个人信息。
          本站暂不提供在线播放、下载、账号注册与支付等功能。
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-home-4-line" /> 返回首页
        </Link>
      </section>
    </div>
  );
}